/**
 * Created by sswaminathan on 1/25/22
 * File: MessageBanner
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { Banner, Body, CopyButton } from '@panwds/react-ui'
/**
 *   TODO: Brief what is this component/class do
 */

import { useCallback, useEffect, useRef, useState, VFC } from 'react'
import Collapse from '../../../common/components/collapse/Collapse'
import type { BannerProps } from '@panwds/react-ui/dist/components/Banner/Banner'
import { CopyIcon, ExclamationCircleIcon } from '@panwds/icons'

const MessageBannerV1: VFC<
  { message: string,
    donNotCloseBanner: boolean,
    timerInMilliSec?: number,
    callBack?: any,
    collapseProps?: any,
    bannerProps?: BannerProps }> =
  ({ message = '',
    donNotCloseBanner = false,
    timerInMilliSec = 5000,
    callBack = () => {},
    collapseProps = {},
    bannerProps = {} }) => {

    const [showMessage, setShowMessage] = useState(true)
    const timeoutRef: any = useRef()

    const closeBanner = useCallback(() => {
      setShowMessage(false)
      clearTimeout(timeoutRef.current)
      if (callBack) {
        callBack()
      }
    }, [callBack])

    useEffect(() => {
      timeoutRef.current = setTimeout(() => {
        !donNotCloseBanner && closeBanner()
      }, timerInMilliSec)
    }, [closeBanner, donNotCloseBanner, timerInMilliSec])

    return (
      <Collapse {...collapseProps} isOpen={showMessage}>
        <Banner
          {...bannerProps}
          type={bannerProps.type || 'page'}
          appearance={bannerProps?.appearance || 'error'}
          showIcon={bannerProps?.showIcon ?? false}
          onClose={closeBanner}
          onClick={!donNotCloseBanner ? closeBanner : () => {}}
        >
          <div className='cm-flex-row cm-flex'>
            <ExclamationCircleIcon size='sm' className='cm-text-red-500 cm-mt-2' />
            <Body size="sm" addClassName='tw-pt-2 tw-pl-2'>{message}</Body>
            <CopyButton appearance={'tertiary-clear'} icon={<CopyIcon size='sm'/>} text={message}/>
          </div>
        </Banner>
      </Collapse>
    )
  }

MessageBannerV1.propTypes = {}

MessageBannerV1.defaultProps = {
  timerInMilliSec: 5000,
}
export default MessageBannerV1
